import React from "react";
import styled from "styled-components";
import { TipBackground } from "../../Utils/Images";
import { useSelector } from "react-redux";

const DiscountIcon = ({ color }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      //   xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0868 2.12123C11.4753 1.5087 10.5156 1.51052 9.90541 2.12727L9.11891 2.91974L9.11634 2.92232C8.49197 3.5461 7.63248 3.90945 6.72175 3.90945H5.59751C4.79248 3.90945 4.02115 4.58797 4.02115 5.56434V6.69334C4.02115 7.5514 3.68368 8.38308 3.06678 9.00822L3.06505 9.00997L2.27062 9.81041C1.62432 10.4637 1.62722 11.5457 2.27737 12.1962L2.27951 12.1984L3.06505 12.9899C3.68385 13.614 4.02115 14.4492 4.02115 15.3043V16.4355C4.02115 17.4114 4.79199 18.0893 5.59751 18.0893H6.72175C7.63354 18.0893 8.49273 18.4545 9.11634 19.0775L9.11849 19.0797L9.91215 19.8783C10.5252 20.4916 11.4846 20.4888 12.0932 19.8722L12.0957 19.8697L12.8823 19.0793L12.8834 19.0782C13.5064 18.4543 14.3662 18.0893 15.2787 18.0893H16.4018C17.2087 18.0893 17.9793 17.4111 17.9793 16.4355V15.3043C17.9793 14.4501 18.3145 13.6149 18.934 12.9902L19.7294 12.1898C20.376 11.5355 20.3724 10.4541 19.7227 9.80328L18.9347 9.01039L18.9325 9.00822C18.315 8.38244 17.9793 7.55049 17.9793 6.69334V5.56434C17.9793 4.58821 17.2082 3.90945 16.4018 3.90945H15.2787C14.3672 3.90945 13.5072 3.54634 12.8834 2.9216L12.8819 2.92016L12.1117 2.14521C12.1033 2.13737 12.095 2.12938 12.0868 2.12123ZM2.23333 5.56434C2.23333 3.79461 3.67552 2.2459 5.59751 2.2459H6.72175C7.11287 2.2459 7.50497 2.09075 7.80694 1.78964C7.80731 1.78927 7.80768 1.7889 7.80805 1.78853L8.59008 1.00056C8.59028 1.00036 8.58988 1.00076 8.59008 1.00056C9.89924 -0.32203 12.0555 -0.335174 13.3791 0.971564C13.3889 0.98056 13.3985 0.989767 13.4079 0.999176L14.1931 1.78924C14.1933 1.78945 14.1929 1.78904 14.1931 1.78924C14.4934 2.08973 14.8859 2.2459 15.2787 2.2459H16.4018C18.3246 2.2459 19.7671 3.79436 19.7671 5.56434V6.69334C19.7671 7.15052 19.9467 7.57582 20.2485 7.88219C20.2488 7.88249 20.2491 7.88278 20.2494 7.88308L21.0325 8.67105C21.0328 8.67132 21.0331 8.6716 21.0334 8.67187C22.3166 9.95813 22.3237 12.0223 21.0455 13.3158L21.0437 13.3176L20.248 14.1182C19.9475 14.4213 19.7671 14.8481 19.7671 15.3043V16.4355C19.7671 18.206 18.3241 19.7528 16.4018 19.7528H15.2787C14.8867 19.7528 14.4944 19.9089 14.1932 20.2105C14.1931 20.2105 14.1932 20.2105 14.1932 20.2105L13.4099 20.9975C13.4095 20.9979 13.4091 20.9984 13.4086 20.9988C12.0943 22.3289 9.92557 22.3344 8.603 21.0112L8.60128 21.0095L7.80805 20.2113C7.80778 20.211 7.80751 20.2108 7.80723 20.2105C7.50446 19.9084 7.11194 19.7528 6.72175 19.7528H5.59751C3.67601 19.7528 2.23333 18.2057 2.23333 16.4355V15.3043C2.23333 14.8492 2.05258 14.4222 1.75163 14.1185L0.968213 13.3291C0.967813 13.3287 0.967413 13.3283 0.967013 13.3279C-0.317652 12.0413 -0.323089 9.97584 0.955296 8.6837L0.956669 8.68231L1.7499 7.88308C1.75015 7.88282 1.74965 7.88334 1.7499 7.88308C2.05248 7.57605 2.23333 7.14968 2.23333 6.69334V5.56434Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4147 7.56311C14.7771 7.87501 14.7992 8.40126 14.464 8.73853L8.8483 14.389C8.51311 14.7263 7.94755 14.7469 7.58508 14.435C7.22262 14.1231 7.20052 13.5968 7.53571 13.2596L13.1515 7.60905C13.4866 7.27179 14.0522 7.25122 14.4147 7.56311Z"
        fill={color}
      />
      <path
        d="M13.8041 14.652C13.5856 14.652 13.378 14.564 13.2251 14.4101C13.1486 14.3332 13.094 14.2342 13.0503 14.1353C13.0066 14.0364 12.9847 13.9385 12.9847 13.8275C12.9847 13.7175 13.0066 13.6076 13.0503 13.5087C13.094 13.4097 13.1486 13.3218 13.2251 13.2448C13.531 12.937 14.0773 12.937 14.3832 13.2448C14.4597 13.3218 14.5252 13.4097 14.5689 13.5087C14.6017 13.6076 14.6236 13.7175 14.6236 13.8275C14.6236 13.9385 14.6017 14.0364 14.5689 14.1353C14.5252 14.2342 14.4597 14.3332 14.3832 14.4101C14.2302 14.564 14.0227 14.652 13.8041 14.652Z"
        fill={color}
      />
      <path
        d="M8.18829 9.00191C8.07904 9.00191 7.9807 8.97882 7.88237 8.93485C7.78404 8.89088 7.68571 8.83701 7.60924 8.76006C7.53276 8.67211 7.47813 8.58417 7.43443 8.48523C7.39072 8.38519 7.36887 8.28735 7.36887 8.17742C7.36887 8.06639 7.39072 7.95755 7.43443 7.85862C7.47813 7.75968 7.53276 7.66074 7.60924 7.59478C7.92608 7.28587 8.46143 7.28587 8.76735 7.59478C8.9203 7.74759 9.00771 7.95756 9.00771 8.17742C9.00771 8.28735 8.99678 8.38519 8.95308 8.48523C8.90938 8.58417 8.84382 8.67211 8.76735 8.76006C8.69087 8.83701 8.60346 8.89088 8.50513 8.93485C8.4068 8.97882 8.29755 9.00191 8.18829 9.00191Z"
        fill={color}
      />
    </svg>
  );
};
export default function Tipheader({ message }) {
  console.log(message.length, "lengthhhhhhh");
  const customTheme = useSelector((state) => state?.theme?.branding);
  const Direction = useSelector((state) => state?.selectLang?.direction);

  return (
    <TipWrapper MessageLength={message?.length}>
      <section style={{ background: customTheme?.theme_color }}>
        <img className="tipheaderbackground" src={TipBackground} alt="tip" />
        {Direction === "ltr" ? (
          <div className="linear-animation-line">
            <p style={{ color: customTheme?.background_color }}>{message}</p>
          </div>
        ) : (
          <div className="linear-animation-lineArb">
            <p style={{ color: customTheme?.background_color }}>{message}</p>
          </div>
        )}
      </section>
    </TipWrapper>
  );
}

const TipWrapper = styled.div`
  width: 100%;
  height: 42px;
  padding: 0 10px;
  overflow: hidden;

  .tipheaderbackground {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .offerIcon {
    width: 30px;
  }
  section {
    position: relative;
    width: 100%;
    height: 42px;
    background: linear-gradient(
      91.33deg,
      rgb(237, 12, 102) 0%,
      rgb(194, 56, 180) 100%
    );
    overflow: hidden;
    .linear-animation-line {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      transform: translateX(${({ MessageLength }) => `${MessageLength * 9}px`});
      animation: my-animation 16s linear infinite;

      @keyframes my-animation {
        from {
          transform: translateX(
            ${({ MessageLength }) => `${MessageLength * 9}px`}
          );
          -moz-transform: translateX(
            ${({ MessageLength }) => `${MessageLength * 9}px`}
          );
          -webkit-transform: translateX(
            ${({ MessageLength }) => `${MessageLength * 9}px`}
          );
        }
        to {
          transform: translateX(
            ${({ MessageLength }) => `-${MessageLength * 9}px`}
          );
          -moz-transform: translateX(
            ${({ MessageLength }) => `-${MessageLength * 9}px`}
          );
          -webkit-transform: translateX(
            ${({ MessageLength }) => `-${MessageLength * 9}px`}
          );
        }
      }

      p {
        font-family: "Poppins";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 18px;
        color: #ffffff;
        padding: 0 5px;
        white-space: nowrap;
        white-space-collapse: preserve;
      }
      svg {
        margin: 2px 0 0 5px;
      }
    }

    .linear-animation-lineArb {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      transform: translateX(${({ MessageLength }) => `${MessageLength * 9}px`});
      animation: my-animationArb 16s linear infinite;

      @keyframes my-animationArb {
        from {
          transform: translateX(
            ${({ MessageLength }) => `-${MessageLength * 9}px`}
          );
          -moz-transform: translateX(
            ${({ MessageLength }) => `-${MessageLength * 9}px`}
          );
          -webkit-transform: translateX(
            ${({ MessageLength }) => `-${MessageLength * 9}px`}
          );
        }
        to {
          transform: translateX(
            ${({ MessageLength }) => `${MessageLength * 9}px`}
          );
          -moz-transform: translateX(
            ${({ MessageLength }) => `${MessageLength * 9}px`}
          );
          -webkit-transform: translateX(
            ${({ MessageLength }) => `${MessageLength * 9}px`}
          );
        }
      }

      p {
        font-family: "Poppins";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 18px;
        color: #ffffff;
        padding: 0 5px;
        white-space: nowrap;
        white-space-collapse: preserve;
      }
      svg {
        margin: 2px 0 0 5px;
      }
    }
  }
`;
